// components/features/support/calls/CallSaveModal.tsx
import { useState } from 'react';
import CallForm from './CallForm';

import { alertError } from '../../../helpers/alertError';
import { Call } from '../../../types/features/Call';
import BaseModal from '../../ui/Modal';
import { callService } from '../../../services/callService';
import useToken from '../../../hooks/features/auth/useToken';

interface CallSaveModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    initialData?: Call;
}

export default function CallSaveModal({
    isOpen,
    onClose,
    onSuccess,
    initialData,
}: CallSaveModalProps) {
    const [isLoading, setIsLoading] = useState(false);
   const {token} = useToken()
    const handleSubmit = async (data: Omit<Call, 'id' | 'created_at' | 'updated_at'>) => {
        try {
            setIsLoading(true);
            console.log(data)
            await callService.createCall(data );
  
            setIsLoading(false);
            onSuccess();
            onClose();
        } catch (error) {
            setIsLoading(false);
            alertError("L'enregistrement de l'appel a échoué")
        }
    };

    const title = initialData ? 'Modifier l\'appel' : 'Nouvel appel';

    return (
        <BaseModal isOpen={isOpen} onClose={onClose} title={title} size="full">
            <CallForm
                initialData={initialData}
                onSubmit={handleSubmit}
                isLoading={isLoading}
            />
        </BaseModal>
    );
}